// src/components/OfflineDetector.jsx
import React, { useEffect, useState } from 'react';
import { success, warning } from "@alert";
import { Z_GLOBAL_OVERLAY } from '@constants/zIndex';

/**
 * 離線狀態檢測組件
 * 監控網路連接狀態，在網路斷開和恢復時顯示提示
 */
const OfflineDetector = () => {
  // 初始值固定為 false，避免 navigator.onLine 在本機開發環境誤判觸發橫幅
  // 只有在真正收到 offline/online 事件時才切換狀態
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      success(0, "連線已恢復", "您的網路連線已恢復，現在可以正常使用所有功能。");
    };

    const handleOffline = () => {
      setIsOffline(true);
      warning(1,
        "網路連線中斷",
        "您目前處於離線狀態，部分功能可能無法使用。網站將嘗試使用已快取的內容，但新的頁面可能無法載入。",
        "我了解了"
      );
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOffline) {
    return (
      <div className="offline-banner" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: '#f44336',
        color: 'white',
        padding: '8px',
        textAlign: 'center',
        zIndex: Z_GLOBAL_OVERLAY, // 9999
        fontSize: '14px'
      }}>
        <span role="img" aria-label="警告" style={{ marginRight: '8px' }}>⚠️</span>
        您目前處於離線狀態，部分功能可能無法正常使用
      </div>
    );
  }

  return null;
};

export default OfflineDetector;